// extracted by mini-css-extract-plugin
module.exports = {"layout":"card-list_layout__1WUhP","selected":"card-list_selected__WgAiv","placeholder":"card-list_placeholder__5ecdR"};